import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getApplication,
  getRolesForApplication,
  getRegistrationsForApplication,
  addRole,
  getAllGroups,
  getLevelsOfAssurance,
} from "../../actions";
import { ContentTable } from "@authzsvc/common-react-components";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { getActiveApplication, isLoading, getGroups } from "../../selectors";
import { FullPageLoader } from "@authzsvc/common-react-components";
import RoleRow from "./RoleRow";
import RoleModal from "./manage-role/RoleModal";
import { boolToCheckmark } from "./manage-role/roleUtils";
import { errorAction, types as at } from "@authzsvc/api-lib";
import { showErrorNotification } from "../../utils";

class Roles extends React.Component {
  static propTypes = {
    loadingRoles: PropTypes.bool,
    loadingApp: PropTypes.bool,
    application: PropTypes.object,
    getApplication: PropTypes.func,
    getRolesForApplication: PropTypes.func,
    addRole: PropTypes.func,
    getLevelsOfAssurance: PropTypes.func,
    active_application: PropTypes.shape({
      application: PropTypes.object,
      roles: PropTypes.array,
    }),
  };

  state = {
    roleModalOpen: false,
  };

  handleRoleOpen = () => this.setState({ roleModalOpen: true });
  handleRoleClose = () => this.setState({ roleModalOpen: false });

  componentDidMount() {
    const id = this.props.application.id;
    this.props.getRolesForApplication(id);
    this.props.getLevelsOfAssurance();
  }

  handleAddRole = (role) => {
    role.applicationId = this.props.active_application.application.id;
    const resp = this.props.addRole(role);
    if (resp && resp.type === errorAction(at.ADD_ROLE)) {
      showErrorNotification(resp.payload.title, resp.payload.data.message);
    }
    this.handleRoleClose();
  };

  render() {
    const { loadingRoles, loadingApp, active_application } = this.props;
    const loading = loadingRoles || loadingApp;

    if (loading || !active_application?.application?.displayName) {
      return <FullPageLoader />;
    }

    const roles = active_application.roles || [];

    const columns = [
      {
        title: "Name",
        dataIndex: "displayName",
        key: "displayName",
      },
      {
        title: "Role Identifier",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
      },
      {
        title: "Required",
        dataIndex: "required",
        key: "required",
        render: boolToCheckmark,
      },
      {
        title: "Multifactor",
        dataIndex: "multifactor",
        key: "multifactor",
        render: boolToCheckmark,
      },
      {
        title: "Apply to all users",
        dataIndex: "applyToAllUsers",
        key: "applyToAllUsers",
        render: boolToCheckmark,
      },
      {
        title: "",
        key: "actions",
        render: (_, role) => <RoleRow role={role} />,
      },
    ];

    return (
      <>
        <ContentTable
          rowKey="id"
          dataSource={roles}
          columns={columns}
          loading={loading}
          locale={{ emptyText: "You have not configured any roles yet" }}
          pagination={false}
          footer={() => (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                id="addRoleButton"
                type="default"
                onClick={() => this.handleRoleOpen()}
                icon={<PlusOutlined />}
              >
                Add a Role
              </Button>
              <RoleModal
                onSubmit={this.handleAddRole}
                onOpen={this.handleRoleOpen}
                onClose={this.handleRoleClose}
                open={this.state.roleModalOpen}
                isEdit={false}
              />
            </div>
          )}
        />
      </>
    );
  }
}

export default connect(
  (state) => ({
    active_application: getActiveApplication(state),
    groups: getGroups(state),
    loadingApp: isLoading(state, "getApplication"),
    loadingRoles: isLoading(state, "getApplicationRoles"),
  }),
  {
    getApplication,
    getRolesForApplication,
    getRegistrationsForApplication,
    addRole,
    getAllGroups,
    getLevelsOfAssurance,
  },
)(Roles);
